module.exports = [
'Kibo Palace Hotel & Resort',
'Xpress Rent A Car Ltd',
'Brett & Beileys (T) Ltd',
'As Salaam Air Company Ltd',
'Milano Panel Beaters & Spray',
'Mic Global Risks (T) Ltd',
'Modern Fittings Mart Ltd',
'Fazal And Company Ltd',
'Javis International Trade Company Ltd',
'Jsp Marketing Link Ltd',
'B Q Contractors Ltd',
'Nzella Company Ltd',
'Gopa Contractors (T) Ltd',
'Inter Consult Ltd',
'Sga Cash In Transit Tanzania Ltd',
'Asher Industries Ltd',
'Next Couriers And Logistics Ltd',
'Welding Alloys (T) Ltd',
'Archers Zanzibar Ltd',
'Freight Intime Ltd',
'Morogoro Plastic Ltd',
'Softnet Technologies Ltd',
'Mwanza Quality Wines Ltd',
'Tanzania At Hoom',
'Tanpack Tissues Ltd',
'Desktop Production Ltd',
'Hotel Sea Cliff',
'Jambo Freight Ltd',
'Meru Spring Water Ltd',
'Green Waste Pro Ltd',
'J S Electromec Ltd',
'Tahafresh Handling Ltd',
'Kiboko Cold Rolling Mills Ltd',
'H. Ladwa Ltd',
'Bm Telecoms And Networks Company Ltd',
'Uwp Consulting (T) Ltd',
'Premier Agencies (T) Ltd',
'Aqua Cool Ltd',
'Mollel Electrical Contractors Ltd',
'Spedag Interfreight (T) Ltd',
'Sanitas Hospital Ltd',
'Office Depot Ltd',
'Adl Logistics Ltd',
'Travel Partner Ltd',
'Vehicle And Equipment Leasing Tanzania Ltd',
'Techno Image Ltd',
'Katani Ltd',
'Sibika Traders And Construction Ltd',
'Imatic Technologies Ltd',
'Tanzania Signwriters & Engravers Ltd',
'Industrial Automation And Electrical System',
'E A Brothers Contractors Company Ltd',
'Lahmeyer Consulting Engineers (T) Ltd',
'Rsa Ltd',
'Care Sanitation And Suppliers Ltd',
'Jaffery Industry Saini Ltd',
'Nimeta Consult (T) Ltd',
'International Dairy Products Ltd',
'Reni International Co.Ltd',
'Tanzania Brush Products Ltd',
'Pivotech Company Ltd',
'Shiv International Ltd',
'Masasi Construction',
'Cats Tanzania Ltd',
'Equity Aviation Services (T) Ltd',
'New Boogaloo Ltd',
'Samiro Pharmaceuticals Ltd',
'Skylink Travel And Tours Ltd',
'Waljis Travel Bureau Ltd',
'Spik And Span Ltd',
'Business Connexion Tanzania Ltd',
'Jcdecaux Tanzania Ltd',
'Perntels Company Ltd',
'Intelligence Securico Ltd',
'Cf Hospital Ltd',
'Darsh Industries Ltd',
'Infosys Ips (T) Ltd',
'Rajinder Motors Ltd',
'Meat King Ltd',
'Magito Stores Company Ltd',
'Hanspaul Industries Ltd',
'N.Shah (1977) Ltd',
'Dowelef International Ltd',
'Achelis (Tanganyika) Ltd',
'Raphael Logistics (T) Ltd',
'Delfina Eco Tourism Promotion Ltd',
'Kearsley Tanzania Ltd',
'Mowara Ltd',
'Skol Building Contractors Ltd',
'Arysta Lifescience Tanzania Ltd',
'Africa Media Group',
'Chloride Exide Tanzania Ltd',
'Hanspaul Automechs Ltd',
'Atsoko Tanzania Ltd',
'Citi One Ltd',
'Sign Industries Ltd',
'Sea Cliff Court Ltd',
'Zenufa Laboratories Ltd',
'Starpeco Ltd',
'Magilatech Company Ltd',

];